(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ygmods-montre-eclatee"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ygx-hero')) return;

  class YgxHero extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('.ygx__canvas');
      this.ctx = this.canvas.getContext('2d');
      this.labels = [...this.querySelectorAll('.ygx__label')];
      this.fallback = this.querySelector('.ygx__fallback');
      this.intro = this.querySelector('.ygx__intro');
      this.mq = window.matchMedia('(max-width: 749px)');
      const d = this.dataset;
      this.base = (d.base || '').trim();
      this.ext = d.ext || 'webp';
      this.pad = parseInt(d.pad, 10) || 3;
      this.start = parseInt(d.start, 10) || 0;
      this.mode = d.mode || 'explode';
      this.fit = d.fit || 'contain';
      this.mobileZoom = (parseInt(d.mobileZoom, 10) || 100) / 100;
      this.labelRoom = 84; // px kept under the watch on phones for the part labels
      this.count = this.base ? parseInt(d.count, 10) || 0 : 0;

      // The preview page hands in ready-made frames instead of URLs.
      const given = window.ygxFrames;
      if (given && given.length) {
        this.frames = given;
        this.count = given.length;
      } else {
        this.frames = new Array(this.count);
      }

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.resize = this.resize.bind(this);
      this.request = this.request.bind(this);

      if (!this.count) {
        this.classList.add('is-static');
        return;
      }
      if (reduced) {
        // One still image instead of the scroll animation.
        this.classList.add('is-static');
        if (!this.fallback) this.showStill();
        return;
      }

      this.classList.add('is-live');
      window.addEventListener('scroll', this.request, { passive: true });
      window.addEventListener('resize', this.resize);
      // On phones the watch starts right under the text, so follow the text's height.
      if (this.intro && 'ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.resize);
        this.ro.observe(this.intro);
      }
      this.resize();
      if (!given) this.load();
      this.request();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.request);
      window.removeEventListener('resize', this.resize);
      if (this.ro) this.ro.disconnect();
      this.stopped = true;
    }

    url(i) {
      let u = this.base + String(i + this.start).padStart(this.pad, '0') + '.' + this.ext;
      if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) {
        const w = this.canvas.clientWidth * Math.min(window.devicePixelRatio || 1, 2);
        u += (u.includes('?') ? '&' : '?') + 'width=' + (w <= 800 ? 800 : w <= 1200 ? 1200 : 1600);
      }
      return u;
    }

    // Coarse frames first so scrubbing works early, then fill the gaps.
    load() {
      const order = [0, this.count - 1];
      const seen = new Set(order);
      for (const step of [16, 8, 4, 2, 1]) {
        for (let i = 0; i < this.count; i += step) {
          if (!seen.has(i)) { seen.add(i); order.push(i); }
        }
      }
      let k = 0;
      let active = 0;
      const next = () => {
        while (!this.stopped && active < 4 && k < order.length) {
          const i = order[k++];
          active++;
          const img = new Image();
          img.decoding = 'async';
          img.onload = () => {
            this.frames[i] = img;
            active--;
            this.request();
            next();
          };
          img.onerror = () => { active--; next(); };
          img.src = this.url(i);
        }
      };
      next();
    }

    showStill() {
      const img = new Image();
      img.onload = () => {
        this.frames[0] = img;
        this.classList.add('has-frame');
        this.resize();
        this.paint(img);
      };
      img.src = this.url(Math.floor(this.count / 2));
    }

    resize() {
      if (this.mq.matches && this.intro) {
        const end = this.intro.offsetTop + this.intro.offsetHeight + 12;
        this.style.setProperty('--ygx-intro-end', end + 'px');
      } else {
        this.style.removeProperty('--ygx-intro-end');
      }
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(this.canvas.clientWidth * dpr);
      this.canvas.height = Math.round(this.canvas.clientHeight * dpr);
      this.last = -1;
      this.request();
    }

    request() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        this.update();
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      const run = rect.height - window.innerHeight;
      const p = run > 0 ? Math.min(1, Math.max(0, -rect.top / run)) : 0;
      this.style.setProperty('--p', p.toFixed(4));

      // Each label stays on from its own position until the next label's position.
      const pct = p * 100;
      const sorted = this.labels
        .map((el) => ({ el, at: parseFloat(el.dataset.at) || 50 }))
        .sort((a, b) => a.at - b.at);
      sorted.forEach((l, i) => {
        const end = i + 1 < sorted.length ? sorted[i + 1].at : 101;
        l.el.classList.toggle('is-on', pct >= l.at && pct < end);
      });

      const fp = this.mode === 'explode_reassemble' ? 1 - Math.abs(1 - 2 * p) : p;
      const want = Math.round(fp * (this.count - 1));
      let idx = -1;
      for (let r = 0; r < this.count; r++) {
        if (this.frames[want - r]) { idx = want - r; break; }
        if (this.frames[want + r]) { idx = want + r; break; }
      }
      if (idx === -1 || idx === this.last) return;
      this.last = idx;
      this.paint(this.frames[idx]);
    }

    // Phones: put the labels right under the watch when they fit there, else over its bottom edge.
    placeLabels(phone, imgBottom) {
      const end = phone ? Math.round(this.canvas.offsetTop + imgBottom) : 0;
      const fits = phone && end + this.labelRoom <= this.canvas.offsetTop + this.canvas.clientHeight + 1;
      if (fits === this.labelsUnder && end === this.imgEnd) return;
      this.labelsUnder = fits;
      this.imgEnd = end;
      this.classList.toggle('has-img-end', fits);
      if (fits) this.style.setProperty('--ygx-img-end', end + 'px');
      else this.style.removeProperty('--ygx-img-end');
    }

    paint(img) {
      const c = this.canvas;
      const iw = img.naturalWidth || img.width;
      const ih = img.naturalHeight || img.height;
      const contain = Math.min(c.width / iw, c.height / ih);
      const cover = Math.max(c.width / iw, c.height / ih);
      const phone = this.mq.matches;
      let scale = this.fit === 'cover' ? cover : contain;
      if (this.fit !== 'cover' && phone) {
        // Phones: grow the watch to fill the space under the text, keeping room for the labels,
        // up to the "Zoom max" setting and never cropping more than "cover" would.
        const dpr = c.width / (c.clientWidth || 1);
        const room = (c.height - this.labelRoom * dpr) / ih;
        scale = Math.max(contain, Math.min(room, cover, contain * this.mobileZoom));
      }
      const w = iw * scale;
      const h = ih * scale;
      // Phones: watch right under the text, labels right under the watch.
      const y = phone && h <= c.height ? 0 : (c.height - h) / 2;
      this.placeLabels(phone, (y + h) / (c.width / (c.clientWidth || 1)));
      this.ctx.clearRect(0, 0, c.width, c.height);
      this.ctx.drawImage(img, (c.width - w) / 2, y, w, h);
    }
  }

  customElements.define('ygx-hero', YgxHero);
})();

  } catch(e) { console.error(e); }
})();
})();
